<template>
  <a-card :bordered="false">
    <a-tabs v-model="activeKey" @change="changeTab">
      <a-tab-pane key="1" :tab="$t('问题确认')">
        <ProblemConfirmation ref="ProblemConfirmationRef"></ProblemConfirmation>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('问题处理')">
        <ProblemHandling ref="ProblemHandlingRef"></ProblemHandling>
      </a-tab-pane>
      <a-tab-pane key="3" :tab="$t('问题记录')">
        <Completed ref="CompletedRef"></Completed>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import ProblemConfirmation from './ProblemConfirmation.vue'
import ProblemHandling from './ProblemHandling.vue'
import Completed from './Completed.vue'
export default {
  name: 'ProblemManagement',
  components: {
    ProblemConfirmation,
    ProblemHandling,
    Completed
  },
  data() {
    return {
      //表头
      activeKey: '1',
    }
  },
  computed: {},
  methods: {
    changeTab(e) {
      if (e == 1) {
        this.$refs.ProblemConfirmationRef.searchReset()
      } else if(e == 2) {
        this.$refs.ProblemHandlingRef.searchReset()
      } else if(e == 3) {
        this.$refs.CompletedRef.searchReset()
      }
    },
  },
  created() {},
  mounted() {},
}
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>